import React from 'react';
import Header from '../Header/Header';

const Blogs = () => {
    return (
        <div>
            <Header props="yes" />
            <article className="my-64">
                <h1 className=" text-center text-4xl my-8"> Blogs Coming Soon</h1>
                <p>Visit <a className="italic underline pt-16" target="_blank" rel="noreferrer" href="https://booktimewithkamil.blogspot.com/"> Book Time With Kamil</a> </p>
            </article>
        </div>
    );
};

export default Blogs;